import { useState, useEffect, MouseEvent } from 'react';

export default function usePopupState() {
  const [visible, setVisible] = useState(false);

  const toggle = (e: MouseEvent, ...args) => {
    e.stopPropagation();
    setVisible(!visible);
  };

  useEffect(() => {
    const close = (e) => {
      setVisible(false);
    };

    window.addEventListener('click', close);

    return () => {
      return window.removeEventListener('click', close);
    };
  }, []);

  return [visible, toggle] as const;
}
